/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const IMPLIED_RANGES = [
  {
    value: '',
    label: '',
  },
  {
    value: 'tdy',
    label: 'Today',
  },
  {
    value: 'fw7',
    label: 'Forward 7 Days',
  },
  {
    value: 'tw',
    label: 'This Week',
  },
  {
    value: 'tm',
    label: 'This Month',
  },
  {
    value: 'ty',
    label: 'This Year',
  },
  {
    value: 'wtd',
    label: 'Week-to-Date',
  },
  {
    value: 'mtd',
    label: 'Month-to-Date',
  },
  {
    value: 'ytd',
    label: 'Year-to-Date',
  },
  {
    value: 'lw',
    label: 'Last Week',
  },
  {
    value: 'lm',
    label: 'Last Month',
  },
  {
    value: 'ly',
    label: 'Last Year',
  },
  {
    value: 'otb',
    label: 'OTB',
  },
];
//
export const dateRangeOptions = {
  ABSOLUTE: 'Absolute',
  RELATIVE: 'Relative',
};
